import { Link } from 'react-router-dom';
import type { Article } from '@/types/content';
import HeatBadge from '@/components/base/HeatBadge';

interface Props {
  article: Article;
  variant?: 'stack' | 'row';
}

const ArticleCard = ({ article, variant = 'stack' }: Props) => {
  if (variant === 'row') {
    return (
      <article className="group flex gap-3 md:gap-4 bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors hover:border-primary-300">
        <Link to={`/article/${article.id}`} className="shrink-0 w-28 sm:w-40 h-24 sm:h-28 overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.category}爆料配图：${article.title}`}
            title={`${article.title} - 爆瓜爆料`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="flex flex-col justify-center gap-1.5 py-3 pr-3 min-w-0">
          <div className="flex items-center gap-2">
            <Link
              to={`/category/${article.categorySlug}`}
              className="text-[11px] text-primary-700 bg-primary-100 rounded-full px-2 py-0.5 whitespace-nowrap"
            >
              {article.category}
            </Link>
            <HeatBadge heat={article.heat} compact />
          </div>
          <h3 className="font-heading text-sm md:text-base font-bold leading-6 text-foreground-900 line-clamp-2">
            <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-800">
              {article.title}
            </Link>
          </h3>
          <p className="hidden sm:block text-xs text-foreground-500 line-clamp-1">{article.excerpt}</p>
          <div className="flex items-center gap-3 text-[11px] text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {article.comments}
            </span>
            <span>{article.publishedAt}</span>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors hover:border-primary-300">
      <Link to={`/article/${article.id}`} className="block w-full h-44 overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.category}爆料配图：${article.title}`}
          title={`${article.title} - 爆瓜爆料`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-col gap-2 p-4 flex-1">
        <div className="flex items-center gap-2">
          <Link
            to={`/category/${article.categorySlug}`}
            className="text-[11px] text-primary-700 bg-primary-100 rounded-full px-2 py-0.5 whitespace-nowrap"
          >
            {article.category}
          </Link>
          <HeatBadge heat={article.heat} compact />
        </div>
        <h3 className="font-heading text-base font-bold leading-6 text-foreground-900 line-clamp-2">
          <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-800">
            {article.title}
          </Link>
        </h3>
        <p className="text-xs leading-5 text-foreground-600 line-clamp-2">{article.excerpt}</p>
        <div className="mt-auto flex items-center justify-between pt-2 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line" />
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line" />
            {article.comments}
          </span>
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;